import { useQueryBuilder } from "../../useBuilders";
import { PAGE_DETAIL, PAGES, SEARCH, SLIDES, STORYBOARD } from "../../queryKeys";
import { storyboardPagesApi } from "src/services/experiences/storyboardSettings/pages";

export const useStoryboardPagesQuery = (storyboardId: string) => {
  return useQueryBuilder(
    [STORYBOARD, PAGES, SEARCH, storyboardId, "50"],
    () => storyboardPagesApi.searchStoryboardPages({ storyboardId, limit: 50 }),
    false,
    5 * 60 * 1000,
    false,
    undefined,
    Boolean(storyboardId),
  );
};

// V2 sections = the storyboard's pages, listed via POST /api/2.0/pages/search.
export const useStoryboardSectionsQuery = (storyboardId?: string, limit = 50) => {
  return useQueryBuilder(
    [STORYBOARD, PAGES, SEARCH, storyboardId ?? "", String(limit)],
    () =>
      storyboardPagesApi.searchStoryboardPages({
        storyboardId: storyboardId as string,
        limit,
      }),
    false,
    0,
    "always",
    undefined,
    Boolean(storyboardId),
  );
};

export const usePageSlidesQuery = (pageId?: string, limit = 50) => {
  return useQueryBuilder(
    [PAGES, SLIDES, pageId ?? "", String(limit)],
    () => storyboardPagesApi.fetchSlidesForPage({ pageId: pageId as string, limit }),
    false,
    0,
    "always",
    undefined,
    Boolean(pageId),
  );
};

export const usePageDetailQuery = (pageId?: string) => {
  return useQueryBuilder(
    [PAGES, PAGE_DETAIL, pageId ?? ""],
    () => storyboardPagesApi.fetchPageDetail(pageId as string),
    false,
    0,
    "always",
    undefined,
    Boolean(pageId),
  );
};
